import { ChatMode } from "../enums/ChatMode";

export default class Constants {
    // Get the timezone name
    static readonly TIMEZONE: string = Intl.DateTimeFormat().resolvedOptions().timeZone;
    // Get the timezone offset in minutes
    static readonly TIMEZONE_OFFSET: number = new Date().getTimezoneOffset();
    static readonly USE_MOCK_SERVICE: boolean = false;
    static readonly CREATE_CLIENT_ROOT: string = "create-client-root";
    static readonly OFFSET: number = 0;
    static readonly HISTORY_LIMIT: number = 28;
    static readonly ChatModeLabels: Record<ChatMode, string> = {
        [ChatMode.FinancePeerReview]: "Peer Bot",
        [ChatMode.Intranet]: "Intranet"
    };
    
    static readonly PEER_BOT_DISCLAIMER: string = "AI-generated content. Be sure to check for accuracy.";
    static readonly FEEDBACK_PDF_CONDITIONS: Record<ChatMode, string[]> = {
        [ChatMode.Intranet]: ['Harmful or offensive'],
        [ChatMode.FinancePeerReview]: [] // Added to satisfy type requirement
    };
    static readonly INTRANET_DISCLAIMER_PREFIX: string = "These generative AI responses are based on the most relevant content from the WTW Intranet. Please refer to the ";
    static readonly INTRANET_RULES_LINK_TEXT: string = "Rules of the Road";
    static readonly INTRANET_RULES_LINK: string = "https://wtwonline.sharepoint.com/sites/Intranet-Resources/SitePages/Intranet-chat-RotR.aspx";
    static readonly MessageContainerClass: string = "messageContainer";
}